import { connect } from 'react-redux'
import ImageSlideEditDialog from './edit-dialog.jsx'
import {
  deleteSlide,
  updateSlide
} from '../../../../stores/presentation/presentation.actions'
import {
  getDeleteSlideRequest,
  getUpdateSlideRequest,
  getSlide
} from '../../../../stores/presentation/presentation.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors.js'
import { closeEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions.js'

const mapStateToProps = state => {
  const editSlideDialog = getEditSlideDialog(state)
  const slide = getSlide(state, editSlideDialog.slideId)
  if (!slide) return { modalOpened: false }
  const updateSlideRequest = getUpdateSlideRequest(state, slide.id)
  const deleteSlideRequest = getDeleteSlideRequest(state, slide.id)
  return {
    slide: slide,
    updating: updateSlideRequest.pending,
    deleting: deleteSlideRequest.pending,
    modalOpened: editSlideDialog.opened && editSlideDialog.type === 'Image',
    title: slide.title,
    html: slide.html_text,
    id: slide.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onClose: () => dispatch(closeEditSlideDialog()),
  onSubmit: values =>
    dispatch(
      updateSlide(stateProps.id, 'Image', {
        title: values.title,
        text: values.text,
        html_text: values.html,
        imagePosition:
          stateProps.slide.imagePosition === 'center'
            ? 'right'
            : stateProps.slide.imagePosition
      })
    ).catch(errorHandler),
  onDelete: () => dispatch(deleteSlide(stateProps.id)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ImageSlideEditDialog)
